import { render, staticRenderFns } from "./FancySnackbar.vue?vue&type=template&id=898c05c4&"
import script from "./FancySnackbar.vue?vue&type=script&lang=js&"
export * from "./FancySnackbar.vue?vue&type=script&lang=js&"
import style0 from "./FancySnackbar.vue?vue&type=style&index=0&id=898c05c4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports